import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, User } from 'firebase/auth';
import {
  connectFirestoreEmulator,
  doc,
  DocumentData,
  DocumentSnapshot,
  enableMultiTabIndexedDbPersistence,
  getDocFromServer,
  getFirestore,
  onSnapshot,
} from 'firebase/firestore';
import { getRemoteConfig } from 'firebase/remote-config';

import { popup } from '../addons/Popup';
import { mapDispatch } from '../utils/redux';

const firebaseConfig = {
  apiKey: "AIzaSyDpS1IWbRFRQd6y5hLEmdQStXZpCTDtC58",
  authDomain: "nilgun-paz-ihr-ith-tic-ltd-sti.firebaseapp.com",
  databaseURL: "https://nilgun-paz-ihr-ith-tic-ltd-sti.firebaseio.com",
  projectId: "nilgun-paz-ihr-ith-tic-ltd-sti",
  storageBucket: "nilgun-paz-ihr-ith-tic-ltd-sti.appspot.com",
  messagingSenderId: "SENDER_ID",
  appId: "1:249353761905:web:3e6c0243323afaba0d57d0",
  measurementId: "G-LJPQC6DRQ5",
};

const app = initializeApp(firebaseConfig);

const analytics = getAnalytics(app);
const auth = getAuth(app);
const firestore = getFirestore(app);
const remoteConfig = getRemoteConfig(app);

// Emulators & Local Dev
if (window.location.hostname === "localhost" && false) {
  connectFirestoreEmulator(firestore, "localhost", 8080);
  // connectStorageEmulator(storage, 'localhost', 9199);
  console.log("using emulators");
}

// Firestore
enableMultiTabIndexedDbPersistence(firestore).catch(console.error);

// Auth
let authProvider: GoogleAuthProvider;

auth.languageCode = "tr";

auth.onAuthStateChanged(async (user) => {
  console.log("auth state changed", user);
  if (user) {
    const ref = doc(firestore, "users", user.uid);
    const update = (
      userdoc: DocumentSnapshot<DocumentData>,
      yielded?: boolean
    ) => {
      if (userdoc.exists()) {
        setAuthState([user, userdoc.data()]);
      } else if (yielded !== true) {
        getDocFromServer(ref).then((fetchedDoc) => {
          console.log(fetchedDoc.metadata);

          if (!fetchedDoc.exists()) {
            console.log(fetchedDoc.ref.path, user.uid);

            popup("Sistemde kayıtlı değilsiniz");
          } else {
            update(userdoc, true);
          }
        });
      }
    };

    onSnapshot(ref, update);
  } else {
    if (window.location.pathname === "/render-pdf") {
      return;
    }

    if (window.location.pathname === "/login" && window.location.hash === "") {
      window.location.hash = "redirecting"

      if (!authProvider) {
        authProvider = new GoogleAuthProvider();
      }
  
      await setAuthState(undefined);
      await signInWithPopup(auth, authProvider);
    }
  }
});

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    userdata: undefined as DocumentData | undefined,
    user: undefined as User | undefined,
  },
  reducers: {
    setState: (
      state,
      action: PayloadAction<[User, DocumentData] | undefined>
    ) => {
      if (!action.payload) {
        delete state.userdata;
        delete state.user;
      } else {
        [state.user, state.userdata] = action.payload;
      }
    },
  },
});

const setAuthState = mapDispatch(authSlice.actions.setState);

export { firebaseConfig, app, analytics, auth, firestore, remoteConfig };
